import { EllipsisTextTooltip } from '@/ui/table/infinite-table/ellipsis-text-tooltip';
import { styled } from 'goober';

export const ProjectOwnerCell = ({ owner }: { owner: string | null }) => {
  if (!owner) {
    return null;
  }
  return <EllipsisTextTooltip text={owner} Component={<Text>{owner}</Text>} />;
};

const Text = styled('p')`
  max-width: 82px;
  ${({ theme }) => theme.typography.globalSearch.suggestionsTable.smallText};
`;
